import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import '../SelectionModal/SelectionModal.css';
import InputFieldsComponent from '../InputFieldsSmall';
import { useDispatch, useSelector } from 'react-redux';
import axios from '../../../utils/axiosExt';
import endpoints from '@config/endpoints';
import { setDistrictByZoneId, setZoneByZoneId } from '@store/actions/zoneDetailsActions';
import Spinner from '../Spinner';
import CrossIcon from '@assets/svg_main/CrossIconBlack.svg';
import Auth from '../../../utils/auth';
import { errorLogger } from '@utils/applicationLogUtils';

interface SelectionProps {
    title: string;
    show: boolean;
    setShowMappedModel: (args: boolean) => void
    id: string
}

const MappedModal: React.FC<SelectionProps> = ({ title, show, setShowMappedModel, id }) => {
    const optionWise = title.split(" ")[0].toLocaleLowerCase();
    const dispatch = useDispatch();
    const [items, setItems] = useState([]);
    const [loading,setLoading]=useState(false);
    useEffect(() => {
        switch (optionWise) {
            case 'district':
                fetchDistrictData();
                break;
            case 'ward':
                fetchWardsData();
                break;
            case 'gram':
                fetchGramPanchayatData();
                break;
            default:
                fetchVillageData();
                break;
        }        
    }, []);

    const fetchDistrictData = async () => {
        setLoading(true);
        const districtByZoneId = await axios.get(`${endpoints.getDistrictsByZDCId(id)}`, Auth.loggedIn());
        const zoneByZoneId = await axios.get(`${endpoints.getZoneDivCircleByZDCId(id)}`, Auth.loggedIn());
        setItems(districtByZoneId.data.data);
        dispatch(setDistrictByZoneId(id, districtByZoneId.data.data));
        dispatch(setZoneByZoneId(id, zoneByZoneId.data.data));
        setLoading(false);
    }

    const fetchWardsData = async () => {
        setLoading(true);
        const wardsResponse = await axios.get(`${endpoints.getWardsByHBSDId(id)}`, Auth.loggedIn());
        setItems(wardsResponse.data.data);
        setLoading(false);

    }

    const fetchVillageData = async () => {
        setLoading(true);
        const villagesResponse = await axios.get(`${endpoints.getVillagesByHBSDId(id)}`, Auth.loggedIn());
        setItems(villagesResponse.data.data);
        setLoading(false);
    }
    const fetchGramPanchayatData = async () => {
        setLoading(true);
        try{
        const gramPanchayatResponse = await axios.get(`${endpoints.getGramPanchayatsByHBSDId(id)}`, Auth.loggedIn());
        setItems(gramPanchayatResponse.data.data);
        }
        catch(error:any){
                  errorLogger(error?.response?.data||error?.response||error)
                }
        setLoading(false);
    }


    return (
        <>
            <Modal
                show={show}
                backdrop={true}
                onHide={() => setShowMappedModel(false)}
                keyboard={false}
                dialogClassName="mapped_modal_page_selection"
            >
                <Modal.Body className="pade_modal_body">
                    <div className="selection-modal-main" style={{ background: 'white', display: "flex", flexDirection: "column" }}>
                        <div className="selection-container-modal"
                            style={{
                                background: 'white',
                                display: "flex",
                                flexDirection: "column"
                            }}>
                            <span className='selection_modal_right_title'
                                style={{
                                    color: '#7f7f7f'
                                    , fontFamily: "Roboto"
                                    , fontSize: "15px"
                                    , margin: "2rem",
                                    height: "fit-content",
                                }}>{title}
                                <span style={{
                                    position:'absolute',
                                    right:'1rem',
                                    cursor:'pointer'
                                }}
                                onClick={()=>setShowMappedModel(false)}
                                >
                                <CrossIcon className="user-cross-icon" />
                                </span>
                                </span>
                            <div className="selection_modal_right" style={{ background: 'white', display: "flex" }}>

                                <div className="selected_modal_grid">
                                    {items?.map((item) =>
                                     optionWise==='gram'?<InputFieldsComponent
                                        inputType={'general'}
                                        placeholder={''}
                                        type={'text'}
                                        key={item['gram_panchayat_id']}
                                        onChange={() => ''}
                                        isDisabled={true}
                                        labelName=""
                                        value={`${item[`gram_panchayat_name`]} - ${item[`gram_panchayat_code`]}`}
                                    />:
                                     <InputFieldsComponent
                                        inputType={'general'}
                                        placeholder={''}
                                        type={'text'}
                                        key={item[`${optionWise}_id`]}
                                        onChange={() => ''}
                                        isDisabled={true}
                                        labelName=""
                                        value={`${item[`${optionWise}_name`]} - ${item[`${optionWise}_code`]}`}
                                    />
                                    )}
                                    {loading && <Spinner/>}
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default MappedModal;
